import { View, StyleSheet, TextInput, Platform } from 'react-native';
import React, { useEffect, useRef, useState } from 'react';
import BMButtonIcon from '../ButtonIcon/BMButtonIcon';
import IcSymbolAddMinus from '@traveloka/district-icon/IcSymbolAddMinus';
import IcSymbolAddPlus from '@traveloka/district-icon/IcSymbolAddPlus';
import { BMPrimitives, useBMTheme } from '../../theme';
import { registerHover, unregisterHover, useHoverable } from '../Hoverable/Hoverable';
const BMNumberStepper = (props) => {
    const { minValue = 0, maxValue = 999, value, onChange, disabled, interval = 1, error, testID } = props;
    const { BMComponents } = useBMTheme();
    const textInputRef = useRef(null);
    const [isDirty, setIsDirty] = useState(false);
    const [isHovered, hoverEventBindings] = useHoverable();
    const [isFocused, setIsFocused] = useState(false);
    const borderColor = error
        ? BMComponents.BMStyleLineBordercolorError
        : isFocused
            ? BMComponents.BMStyleLineBordercolorFocus
            : 'transparent';
    //handlers
    const handleNumberValue = (value) => {
        const newVal = Number(value);
        if (newVal < minValue)
            return minValue;
        else if (newVal > maxValue)
            return maxValue;
        else
            return newVal;
    };
    const handleChange = (newValue) => {
        const newVal = handleNumberValue(String(newValue).replace(/\D/g, ''));
        if (!isDirty)
            setIsDirty(true);
        if (newVal != value)
            onChange === null || onChange === void 0 ? void 0 : onChange(newVal);
    };
    const handleFocus = () => {
        setIsFocused(true);
    };
    const handleBlur = () => {
        setIsFocused(false);
    };
    // effects
    // value change
    useEffect(() => {
        const newVal = handleNumberValue(value !== null && value !== void 0 ? value : 0);
        if (value != newVal)
            onChange === null || onChange === void 0 ? void 0 : onChange(newVal);
    }, [minValue, maxValue]);
    // register hover
    useEffect(() => {
        registerHover();
        return () => {
            unregisterHover();
        };
    }, []);
    return (<View style={styles.container} {...hoverEventBindings} testID={testID}>
      <View style={styles.buttonContainer}>
        <BMButtonIcon onPress={() => handleChange(Number(value) - interval)} Icon={IcSymbolAddMinus} disabled={!(value > minValue) || disabled}/>
      </View>
      <View style={[
            styles.inputContainer,
            {
                borderColor,
                borderWidth: isFocused && !error ? 3 : 1,
                backgroundColor: disabled
                    ? BMComponents.BMStyleSurfaceBgcolorDisabled
                    : isHovered
                        ? BMComponents.BMStyleSurfaceBgcolorInventory
                        : BMComponents.BMStyleSurfaceBgcolor,
                borderRadius: isHovered || error || isFocused ? BMPrimitives.BMBorder.radius.default : 0,
            },
        ]}>
        <TextInput ref={textInputRef} style={[
            styles.input,
            BMPrimitives.BMTypography.uiLarge,
            {
                color: disabled
                    ? BMComponents.BMStyleTextInkMuted
                    : isDirty
                        ? BMComponents.BMStyleTextInkPrimary
                        : BMComponents.BMStyleTextInkSecondary,
            },
            Platform.select({
                ios: {
                    lineHeight: 0,
                },
            }),
        ]} value={String(value)} onChangeText={(text) => handleChange(text)} editable={!disabled} keyboardType={'number-pad'} onFocus={handleFocus} onBlur={handleBlur}/>
      </View>

      <View style={styles.buttonContainer}>
        <BMButtonIcon onPress={() => handleChange(Number(value) + interval)} Icon={IcSymbolAddPlus} disabled={!(value < maxValue) || disabled}/>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'flex-start',
    },
    inputContainer: {
        minWidth: 48,
        marginHorizontal: BMPrimitives.BMSize.xs,
        height: 32,
        justifyContent: 'center',
        flex: 1,
    },
    input: {
        // @ts-ignore
        outlineStyle: 'none',
        textAlign: 'center',
        margin: 0,
        padding: 0,
    },
    border: {
        position: 'absolute',
        marginHorizontal: 'auto',
        zIndex: -10,
    },
    buttonContainer: {
        // @ts-ignore
        flex: 'initial',
    },
});
export default BMNumberStepper;
